"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _RadioButtonUnchecked = _interopRequireDefault(require("@material-ui/icons/RadioButtonUnchecked"));

var _RadioButtonChecked = _interopRequireDefault(require("@material-ui/icons/RadioButtonChecked"));

var _utils = require("../utils");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var Flags = function Flags(_ref) {
  var handleChange = _ref.handleChange,
      activeLang = _ref.activeLang;

  var Image = function Image(_ref2) {
    var img = _ref2.img,
        _ref2$medium = _ref2.medium,
        medium = _ref2$medium === void 0 ? false : _ref2$medium;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      className: "".concat(_styleModule.default.flag, " ").concat(medium ? _styleModule.default.medium : ''),
      alt: activeLang,
      src: img
    });
  };

  var change = function change(e) {
    handleChange(e.target.value);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Box, {
    className: _styleModule.default.radioGroup,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.RadioGroup, {
      name: "languages",
      value: activeLang,
      onChange: change,
      children: _utils.languages.map(function (lang) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.FormControlLabel, {
          value: lang.value,
          className: _styleModule.default.formControlLabel,
          labelPlacement: "end",
          control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Radio, {
            className: _styleModule.default.radioBtn,
            icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RadioButtonUnchecked.default, {
              className: _styleModule.default.sizeIconEmpty
            }),
            checkedIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RadioButtonChecked.default, {
              className: _styleModule.default.sizeIconChecked
            })
          }),
          label: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: _styleModule.default.label,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Image, {
              img: lang.image,
              medium: true
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Box, {
              className: _styleModule.default.textLabel,
              component: "span",
              children: lang.valueText
            })]
          })
        }, "option_".concat(lang.value));
      })
    })
  });
};

var _default = Flags;
exports.default = _default;